import { createReducer, on } from '@ngrx/store';
import { ShoppingCartState } from '@shared-models';
import {
  acceptPolicyAction,
  addToCartAction,
  emptyShoppingCartAction,
  focusAcceptPolicyAction,
  removeProductFromCartAction,
  saveShoppingCartIdAction,
  togglePaymentCancelAction,
  togglePaymentErrorAction,
  togglePaymentSuccessfulAction,
  toggleShoppingCartAction,
  updateArticleInCartAction,
} from '@store-shopping-cart-actions';

export const initialShoppingCartState: ShoppingCartState = {
  shoppingCartShown: false,
  paymentSuccessfulShown: false,
  paymentErrorShown: false,
  paymentCancelShown: false,
  shoppingCartItems: [],
  acceptPolicy: false,
  focusAcceptPolicy: false,
  shoppingCartId: '',
};

export const shoppingCartReducer = createReducer(
  initialShoppingCartState,
  on(toggleShoppingCartAction, (state, action) => ({
    ...state,
    shoppingCartShown: action.showCart,
  })),

  on(togglePaymentSuccessfulAction, (state, action) => ({
    ...state,
    paymentSuccessfulShown: action.showMessage,
  })),

  on(togglePaymentCancelAction, (state, action) => ({
    ...state,
    paymentCancelShown: action.showMessage,
  })),

  on(togglePaymentErrorAction, (state, action) => ({
    ...state,
    paymentErrorShown: action.showMessage,
  })),

  on(addToCartAction, (state, action) => {
    const existingEntry = state.shoppingCartItems.find(
      item => item.date === action.cartEntry.date,
    );

    if (existingEntry) {
      return {
        ...state,
        shoppingCartItems: state.shoppingCartItems.map(item =>
          item.date === action.cartEntry.date
            ? {
                ...item,
                products: [...item.products, ...action.cartEntry.products],
              }
            : item,
        ),
      };
    } else {
      return {
        ...state,
        shoppingCartItems: [...state.shoppingCartItems, action.cartEntry],
      };
    }
  }),

  on(removeProductFromCartAction, (state, action) => {
    const entryIndex = state.shoppingCartItems.findIndex(
      item => item.date === action.date,
    );

    if (entryIndex > -1) {
      const entry = state.shoppingCartItems[entryIndex];

      const cartProducts = entry.products.filter(p => p.uniqueId !== action.uniqueId);
      const updatedProducts = cartProducts.map(product => ({
        ...product,
        gearData: product.gearData.filter(g => g.uniqueId !== action.uniqueId),
      }));

      const updatedEntry = {
        ...entry,
        products: updatedProducts,
      };

      const updatedCart = [...state.shoppingCartItems];
      updatedCart[entryIndex] = updatedEntry;

      return {
        ...state,
        shoppingCartItems: updatedCart,
      };
    }
    return state;
  }),

  on(updateArticleInCartAction, (state, action) => {
    const existingEntryIndex = state.shoppingCartItems.findIndex(
      item => item.date === undefined,
    );

    if (existingEntryIndex >= 0) {
      const products = state.shoppingCartItems[existingEntryIndex].products.map(_ => {
        if (_.productId === action.item.productId) {
          return {
            ..._,
            quantity: action.item.quantity,
          };
        }

        return {
          ..._,
        };
      });

      return {
        ...state,
        shoppingCartItems: state.shoppingCartItems.map((item, index) =>
          index === existingEntryIndex ? { ...item, products } : item,
        ),
      };
    }

    return state;
  }),

  on(emptyShoppingCartAction, state => ({
    ...state,
    shoppingCartItems: [],
  })),

  on(acceptPolicyAction, (state, action) => ({
    ...state,
    acceptPolicy: action.accept,
  })),

  on(focusAcceptPolicyAction, (state, action) => ({
    ...state,
    focusAcceptPolicy: action.focus,
  })),

  on(saveShoppingCartIdAction, (state, action) => ({
    ...state,
    shoppingCartId: action.cartId,
  })),
);
